import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";
import axios from "axios";
import Geofences from "../Geofences";

const PartnerGeofencesModal = props => {
  const { partner } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [geofences, setGeofences] = useState([...(partner.geofences || [])]);
  const [geofencesToDelete, setGeofencesToDelete] = useState([]);

  // tells us if a new geofence has been added to the original list
  const [geofencesChanged, setGeofencesChanged] = useState(false);

  const token = sessionStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const onSelect = geofence => {
    const isDuplicate = geofences.map(g => g.slug).includes(geofence.slug);
    if (!isDuplicate) {
      setGeofencesChanged(true);

      setGeofences(prevValue => [...prevValue, geofence]);
    }
  };

  const removeGeofence = index => {
    return () => {
      const toDelete = geofences[index];

      // check if removed business has already been saved to back end, not added and removed in this view before saving
      const geofenceHasPersisted = partner.geofences.some(
        g => g.slug === toDelete.slug
      );

      if (geofenceHasPersisted) {
        setGeofencesToDelete(prevValue => [...prevValue, toDelete.slug]);
      }

      setGeofences(prevValue => [
        ...prevValue.slice(0, index),
        ...prevValue.slice(index + 1)
      ]);
    };
  };

  const renderSelected = () => {
    return geofences.map((g, idx) => {
      return (
        <div className="pill" key={g.slug}>
          {g.slug}{" "}
          <i
            onClick={removeGeofence(idx)}
            className="icon-close"
            style={{ fontSize: 16, marginLeft: 5, cursor: "pointer" }}
          />
        </div>
      );
    });
  };

  const addGeofences = () => {
    const payload = createPayload();
    return axios.post(
      `api/proxy/v2/partneradmin/${partner.id}/geofences`,
      payload,
      { headers }
    );
  };

  const deleteGeofences = () => {
    return axios.delete(`api/proxy/v2/partneradmin/${partner.id}/geofences`, {
      data: { geofences: geofencesToDelete },
      headers
    });
  };

  const onSubmit = async () => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      setIsSubmitting(true);
      let updatedPartner = { ...partner };

      if (geofencesChanged) {
        const { data } = await addGeofences();

        updatedPartner = data;
      }

      if (geofencesToDelete.length) {
        const { data: deleteData } = await deleteGeofences();

        updatedPartner = deleteData;
      }

      props.onSuccess(updatedPartner);
    } catch (e) {
      console.log(e.response || e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const createPayload = () => {
    return {
      geofences: geofences.map(g => g.slug)
    };
  };

  return (
    <Modal isOpen={props.isOpen} className={props.className}>
      <ModalHeader toggle={props.close}>Edit Partner Info</ModalHeader>
      <ModalBody>
        <div className="pill-container">
          {renderSelected()}
          <Button
            onClick={onSubmit}
            style={{ backgroundColor: "#20bed6", color: "#fff" }}
            className="pull-right"
          >
            {isSubmitting && (
              <i
                className="fa fa-circle-o-notch fa-spin"
                style={{ marginRight: 5 }}
              />
            )}
            Save
          </Button>
        </div>
        <Geofences isPartnership onSelect={onSelect} />
      </ModalBody>
    </Modal>
  );
};

export default PartnerGeofencesModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/PartnerGeofencesModal.js